import React, { useRef } from "react";
import { totalRotation, visibleSize } from "./geometry";
import { useInView, usePageRender } from "./usePageRender";

const THUMB_W = 112;

export default function PageThumb({ page, pdfDoc, index, active, dragOver, onClick, onDragStart, onDragOver, onDrop, onDragEnd }) {
  const hostRef = useRef(null);
  const canvasRef = useRef(null);
  const visible = useInView(hostRef, "400px");
  const R = totalRotation(page);
  const v = visibleSize(page.W, page.H, R);
  const height = (THUMB_W * v.h) / v.w;

  usePageRender(canvasRef, pdfDoc, page, THUMB_W / v.w, visible);

  return (
    <div
      ref={hostRef}
      draggable
      onClick={onClick}
      onDragStart={onDragStart}
      onDragOver={onDragOver}
      onDrop={onDrop}
      onDragEnd={onDragEnd}
      className="text-center mb-3"
      style={{ cursor: "pointer" }}
    >
      <div
        className="position-relative d-inline-block bg-white"
        style={{
          width: THUMB_W,
          height,
          borderRadius: 6,
          outline: active ? "3px solid #0c76e5" : dragOver ? "3px dashed #0c76e5" : "1px solid #cbd5e1",
          boxShadow: "0 4px 10px rgba(12,118,229,0.10)",
        }}
      >
        <canvas ref={canvasRef} style={{ width: THUMB_W, height, display: "block", borderRadius: 6 }} />
        {page.objects.length ? (
          <span
            className="position-absolute"
            title="มีการแก้ไขในหน้านี้"
            style={{ top: 4, right: 4, width: 10, height: 10, borderRadius: "50%", background: "#0c76e5", border: "2px solid #fff" }}
          />
        ) : null}
      </div>
      <div className="small mt-1" style={{ color: active ? "#0c76e5" : "#566575", fontWeight: active ? 600 : 400 }}>{index + 1}</div>
    </div>
  );
}
